import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import { Block, Text } from '../../../../../../components';
import ModalConfirmation from '../../../../components/Modal/Modal';
import Spinner from '../../../../../../components/Spinner';
import Processing from '@/presentation/components/Processing';
import Step from '../../../requests/UpdatePhoto/Register/components/Step';
import {
  ContainerProcedure,
  ButtonBack,
  SubContainer
} from '../info/components';
import { TextTitle, ToggleHeader } from '../register/components';
import CardInProgress from './components/CardInProgress';
import ConfirmAction from './components/ConfirmAction';
import routes from '../../../../../../components/Routes/routingMap';
import { InteractiveButton } from '../../../../components';
import ProgressDataUser from './components/ProgressDataUser';
import Snackbar from '../../../../../../components/Snackbar';
import ContentModalOneButton from '../../../../components/ContentModalOneButton';
import iconIlustration from '../../../../../../../assets/icons/illustration.svg';
import constants from '../../../../constants';
import CardProgress from '@/presentation/reusables/CardProgress';
import documentFailedImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed.svg';
import documentFailedDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed-dsk.svg';

interface CertificateType01ProgressViewProps {
  isLoadingCancel: boolean;
  procedure: any;
  request: any;
  isLoading: boolean;
  isComplete: boolean;
  showModal: boolean;
  showExternal: boolean;
  showAnulate: boolean;
  handlerCloseModal: () => void;
  handlerStepAction: () => void;
  handlerShowAnulate: () => void;
  handlerOkModal: () => void;
  isLoadingActivatePayment: boolean;
  isSuccessActivatePayment: boolean;
  detail: any;
  selectedProcedureId: any;
  handleCloseExternal: () => void;
  fieldsSnackbar: any;
}

const CertificateType01ProgressView: React.FC<
  CertificateType01ProgressViewProps
> = (props) => {
  const history = useHistory();

  const {
    isLoadingCancel,
    procedure,
    request,
    isLoading,
    isComplete,
    showModal,
    showAnulate,
    handlerCloseModal,
    handlerStepAction,
    handlerShowAnulate,
    handlerOkModal,
    isLoadingActivatePayment,
    isSuccessActivatePayment,
    detail,
    selectedProcedureId,
    handleCloseExternal,
    showExternal,
    fieldsSnackbar
  } = props;
  const isCreatedOrActived = ['CREADO', 'PAGO_ACTIVADO'].includes(
    request?.status?.status
  );
  const evalStatus = () =>
    constants.procedureStatus.certificatesType01.find(
      (s: any) => s.name === request?.status.status
    );
  return (
    <ContainerProcedure>
      <Processing isOpen={isLoadingCancel || isLoadingActivatePayment} />
      <ModalConfirmation
        show={showModal && !isLoadingCancel && !isLoadingActivatePayment}
        handleClose={handlerCloseModal}
      >
        <ConfirmAction
          activatePayment={request?.status?.status === 'CREADO'}
          gotoPayment={request?.status?.status === 'PAGO_ACTIVADO'}
          anulate={false}
          handleClickConfirm={handlerOkModal}
          handleClickCancel={handlerCloseModal}
          amount={procedure?.amount}
        />
      </ModalConfirmation>
      <ModalConfirmation
        show={isSuccessActivatePayment}
        handleClose={handlerCloseModal}
      >
        <ConfirmAction
          activatePayment={false}
          gotoPayment
          anulate={false}
          handleClickConfirm={handlerOkModal}
          handleClickCancel={handlerCloseModal}
          amount={procedure?.amount}
        />
      </ModalConfirmation>
      <ModalConfirmation
        show={showAnulate && !isLoadingCancel}
        handleClose={handlerCloseModal}
      >
        <ConfirmAction
          activatePayment={false}
          gotoPayment={false}
          anulate
          handleClickConfirm={handlerOkModal}
          handleClickCancel={handlerCloseModal}
          amount={procedure?.amount}
        />
      </ModalConfirmation>
      {isLoading && <Spinner />}
      {request && !isLoading && (
        <SubContainer>
          <ButtonBack
            onClick={() => history.push(routes.student.procedures.home)}
          />
          <ToggleHeader
            name={procedure?.name}
            amount={procedure?.amount}
            duration={procedure?.duration}
            pin1={procedure?.pin1}
            status={request?.status}
          />
          <TextTitle title="Progreso" />
          <Block
            customized
            maxWidth={isMobile ? '100%' : '552px'}
            padding={isMobile ? '28px 0px 0px 8px' : '28px 0px 0px 16px'}
          >
            <Step
              isFirst
              name={procedure.steps[0].name}
              order={procedure.steps[0].order}
              date={procedure.steps[0].date?.toLowerCase()}
              isComplete={procedure.steps[0].isComplete}
              isCurrent={procedure.steps[0].isCurrent}
            >
              {detail && (
                <ProgressDataUser
                  procedureId={selectedProcedureId}
                  period={detail?.periodDesc}
                  periodId={detail?.periodId}
                  career={detail?.program}
                  weightedAverage={detail?.weightedAverage}
                  hasDebts={detail?.hasDebts}
                  selectedProcedureId={selectedProcedureId}
                />
              )}
            </Step>
            <Step
              name={procedure.steps[1].name}
              order={procedure.steps[1].order}
              // date={isCreatedOrActived ? '' : procedure.steps[1].date}
              isComplete={
                evalStatus()?.name === 'ANULADO' ? false : !isCreatedOrActived
              }
              isCurrent={procedure.steps[1].isCurrent}
              disabled={evalStatus()?.name === 'ANULADO'}
            >
              <>
                <Text fontSize="12px">
                  {isCreatedOrActived
                    ? ''
                    : procedure.steps[1].date?.toLowerCase()}
                </Text>
                {isCreatedOrActived && (
                  <CardInProgress
                    availableDays={request?.availableDays}
                    activatePayment={request.status.status === 'CREADO'}
                    paymentActivated={request.status.status === 'PAGO_ACTIVADO'}
                    isFinished={false}
                    onClick={handlerStepAction}
                  />
                )}
              </>
            </Step>
            <Step
              name={procedure.steps[2].name}
              order={procedure.steps[2].order}
              // date={procedure.steps[2].date}
              isComplete={evalStatus()?.name === 'ANULADO' ? true : isComplete}
              isCurrent={procedure.steps[2].isCurrent}
              disabled={
                evalStatus()?.name === 'ANULADO'
                  ? false
                  : !procedure.steps[2].isCurrent
              }
              isLast
            >
              <Text fontSize="12px">
                {isCreatedOrActived
                  ? ''
                  : procedure.steps[2].date?.toLowerCase()}
              </Text>
              {procedure.steps[2].isCurrent &&
                (evalStatus()?.name !== 'ANULADO' ? (
                  <CardInProgress
                    availableDays={request?.expiredFile}
                    activatePayment={false}
                    paymentActivated={false}
                    isFinished
                    onClick={handlerOkModal}
                    textInfo
                  />
                ) : (
                  <CardProgress
                    image={[documentFailedImage, documentFailedDskImage]}
                    title={`Tu solicitud se ha anulado`}
                    subtitle="No pagaste a tiempo el monto de tu trámite."
                  />
                ))}
            </Step>
          </Block>
          {evalStatus()?.name !== 'ANULADO' && !isComplete && (
            <Block style={{ alignSelf: isMobile ? 'center' : 'flex-start' }}>
              <InteractiveButton
                bkgColorEnabled="none"
                bkgColorHover="#E2DFFD"
                bkgColorFocus="#C6C0FC"
                bkgColorPressed="#C6C0FC"
                customized
                border="1px solid #5B36F2"
                alignItems="center"
                backgroundColor="#FFFFFF"
                padding="9px 0px"
                margin={isMobile ? '12px 0px 20px 0px' : '0px 0px 20px 0px'}
                borderRadius="4px"
                width="130px"
                justifyContent={isMobile ? 'center' : 'flex-start'}
                display="flex"
                onClick={handlerShowAnulate}
              >
                <Text
                  color="#5B36F2"
                  fontSize="14px"
                  lineHeight="20px"
                  fontWeight="700"
                  textAlign="center"
                  width="150px"
                >
                  Anular solicitud
                </Text>
              </InteractiveButton>
            </Block>
          )}
        </SubContainer>
      )}
      <div
        style={{ width: '100%', position: 'fixed', bottom: '1rem', left: 0 }}
      >
        <Snackbar timeout={5000} fieldsSnackbar={fieldsSnackbar} />
      </div>

      <ModalConfirmation show={showExternal} handleClose={handleCloseExternal}>
        <ContentModalOneButton
          img={iconIlustration}
          title="¡Oh no!"
          subtitle={
            <>
              *Si el problema persiste, por favor comunícate con nosotros:
              <br />
              <b>0801 19600</b> o <b>315 9600</b>
            </>
          }
          subtitle0="Parece que ha ocurrido un error"
          showInfo={false}
          info={
            <>
              Esta solicitud también está disponible en <b>UTP+ App</b>
            </>
          }
          textButton="Entendido"
          onClickButton={() => {
            handleCloseExternal();
          }}
        />
      </ModalConfirmation>
    </ContainerProcedure>
  );
};

export default CertificateType01ProgressView;
